import { User } from '../../shared/models/user.interface';
import { accountCommandsForUser, accountUrlForUser } from '../account/account-path';
import { isPrivilegedUser } from '../auth/role.utils';

/** `staff` may open any tenant, but the caller still has to check that it exists. */
export type TenantAccess =
  { kind: 'staff' } | { kind: 'allow' } | { kind: 'redirect'; commands: string[] };

/** Whether `user` may open `/tenant/:tenantId`. Everyone but staff is confined to their own tenant. */
export function resolveTenantAccess(user: User, tenantId: string): TenantAccess {
  if (isPrivilegedUser(user)) {
    return { kind: 'staff' };
  }
  const own = user.tenant;
  if (!own || own.is_active === false) {
    return { kind: 'redirect', commands: accountCommandsForUser(user) };
  }
  if (own.id !== tenantId) {
    return { kind: 'redirect', commands: ['/tenant', own.id] };
  }
  return { kind: 'allow' };
}

/**
 * Where a tenant-less URL such as `/tenant/settings/users` should land now that
 * pages live under `/tenant/:tenantId`. `rest` is everything after `/tenant`.
 */
export function legacyTenantRedirect(user: User, rest: string): string {
  if (isPrivilegedUser(user)) {
    return '/admin/tenants';
  }
  if (user.tenant && user.tenant.is_active !== false) {
    return `/tenant/${user.tenant.id}${rest === '/' ? '' : rest}`;
  }
  return accountUrlForUser(user);
}
